import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ListingCard from "../components/ListingCard";
import { Reveal } from "../components/Motion";
import { api } from "../lib/api";

const CATS = [
  { v: "all", l: "All" },
  { v: "goods", l: "Goods" },
  { v: "jewelry", l: "Jewelry" },
  { v: "vehicles", l: "Vehicles" },
];

export default function MarketplacePage() {
  const [listings, setListings] = useState([]);
  const [cat, setCat] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/listings", { params: cat === "all" ? {} : { category: cat } }).then(({ data }) => setListings(data)).finally(() => setLoading(false));
  }, [cat]);

  return (
    <div className="bg-[#050505] min-h-screen">
      <Nav />
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-32 md:pt-40 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[var(--text-secondary)] hover:text-white transition-colors mb-10"><ArrowLeft size={14} /> Back home</Link>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <h1 className="font-display text-6xl md:text-8xl font-black uppercase tracking-tighter leading-[0.85]">The<br />Marketplace</h1>
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button key={c.v} data-testid={`cat-${c.v}`} onClick={() => setCat(c.v)} className={`px-5 py-2.5 font-mono text-xs uppercase tracking-widest border transition-colors ${cat === c.v ? "bg-[var(--accent)] border-[var(--accent)] text-white" : "border-[var(--border-dim)] text-[var(--text-secondary)] hover:border-white"}`}>{c.l}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <p className="font-mono text-sm text-[var(--text-secondary)]">Loading listings…</p>
        ) : listings.length === 0 ? (
          <p className="font-mono text-sm text-[var(--text-secondary)]" data-testid="marketplace-empty">No items in this category yet. Check back soon.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="marketplace-grid">
            {listings.map((l, i) => (
              <Reveal key={l.id} delay={(i % 4) * 0.05}><ListingCard listing={l} testid={`listing-${l.id}`} /></Reveal>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
